import * as React from "react";
import SearchIcon from "assets/icons/search-icon.png";
import CloseIcon from "assets/svgIcons/CloseIcon";
import {
  Container,
  SearchWrapper,
  CarContainer,
} from "pages/Map/CarList/CarListStyled";
import CarInfoCard from "./CarInfoCard";
import { useTranslation } from "react-i18next";

const CarList = ({ setActiveCarList, isActiveCarList, displayCars }) => {
  const { t } = useTranslation();
  const closeButtonHandler = () => {
    setActiveCarList(!isActiveCarList);
  };

  const [searchInput, setSearchInput] = React.useState("");
  const searchInputHandler = (e) => {
    setSearchInput(e.target.value);
  };

  return (
    <Container>
      <div className="header">
        <h4>{t("Car_List")}</h4>
        <CloseIcon
          onClick={closeButtonHandler}
          color="#fff"
          width={18}
          height={18}
        />
      </div>
      <SearchWrapper>
        <input
          type="text"
          placeholder={t("Search_car_no")}
          value={searchInput}
          onChange={searchInputHandler}
        />
        <img src={SearchIcon} alt="search-icon" />
      </SearchWrapper>

      <CarContainer>
        {displayCars() && displayCars().length !== 0
          ? displayCars()
            .filter((cars) => {
              if (searchInput === "") {
                return cars;
              } else if (
                cars.Car.CarNumber.toString()
                  .toLowerCase()
                  .includes(searchInput.toLowerCase())
              ) {
                return cars;
              }
            })
            .sort((a, b) => a.Car?.CarNumber - b.Car?.CarNumber)
            .map((cars, index) => (
              <CarInfoCard
                key={index}
                car={cars}
              />
            ))
          : t("No_Cars_to_Show")}
      </CarContainer>
    </Container>
  );
};
export default CarList;
